import { Injectable } from '@angular/core';

import { AuthService, ConfigService } from '../../../../../core';
import { isClienteAnaliseFinanceiraStatusPendente, isClienteAnaliseFinanceiraStatusEmAnalise, isClienteAnaliseFinanceiraStatusConcluida } from '../status';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseFinanceiraAuthGuardService {

    constructor(private authService: AuthService,
                private configService: ConfigService) { }

    /** Verifica se pode visualizar a análise financeira dos clientes */
    canVisualizar(): boolean {
        // Opção de realizar análise financeira não ativa na config. dos clientes
        if (!this.configService.getCliente()?.realizaAnaliseFinanceira) {
            return false;
        }

        return true;
    }

    /** Verifica se pode visualizar a análise financeira do cliente informado */
    canVisualizarCliente(idCliente: number): boolean {
        // Se não puder visualizar a análise financeira
        if (!this.canVisualizar()) {
            return false;
        }

        // Cliente não informado ou um novo cadastro
        if (!idCliente || idCliente <= 0) {
            return false;
        }

        return true;
    }

    /** Verifica se pode realizar a análise financeira do cliente */
    canRealizar(): boolean {
        // Opção de realizar análise financeira não ativa na config. dos clientes
        if (!this.configService.getCliente()?.realizaAnaliseFinanceira) {
            return false;
        }

        // Se não for um usuário do financeiro
        if (!this.authService.isFinanceiro()) {
            return false;
        }

        return true;
    }

    /** Verifica se pode iniciar a análise financeira do cliente */
    canIniciar(status: number): boolean {
        // Se não puder realizar a análise financeira do cliente
        if (!this.canRealizar()) {
            return false;
        }

        // Se não estiver com status igual a pendente
        if (!isClienteAnaliseFinanceiraStatusPendente(status)) {
            return false;
        }

        return true;
    }

    /** Verifica se pode cancelar o inicio da análise financeira do cliente */
    canCancelarIniciar(status: number): boolean {
        // Se não puder realizar a análise financeira do cliente
        if (!this.canRealizar()) {
            return false;
        }

        // Se não estiver com status igual a em análise
        if (!isClienteAnaliseFinanceiraStatusEmAnalise(status)) {
            return false;
        }

        return true;
    }

    /** Verifica se pode concluir a análise financeira do cliente */
    canConcluir(status: number): boolean {
        // Se não puder realizar a análise financeira do cliente
        if (!this.canRealizar()) {
            return false;
        }

        // Se não estiver com status igual a em análise
        if (!isClienteAnaliseFinanceiraStatusEmAnalise(status)) {
            return false;
        }

        return true;
    }

    /** Verifica se pode cancelar a conslusão a análise financeira do cliente */
    canCancelarConcluir(status: number): boolean {
        // Se não puder realizar a análise financeira do cliente
        if (!this.canRealizar()) {
            return false;
        }

        // Se não estiver com status igual a concluída
        if (!isClienteAnaliseFinanceiraStatusConcluida(status)) {
            return false;
        }

        return true;
    }

    /** Verifica se pode revisar a análise financeira do cliente */
    canRevisar(status: number): boolean {
        // Se não puder realizar a análise financeira do cliente
        if (!this.canRealizar()) {
            return false;
        }

        // Se não estiver com status igual a concluída
        if (!isClienteAnaliseFinanceiraStatusConcluida(status)) {
            return false;
        }

        return true;
    }
}
